module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.1d90f774.m4a";